/* OurKids homepage behaviour.
   ok-product-rail.liquid has always referenced this file, but it was never
   created — so the rail quick-add forms had no handler, stuck on "Adding…",
   never opened the drawer and never moved the cart count. */
(function () {
  if (window.__okHome) return;
  window.__okHome = true;

  function setCount(n) {
    document.querySelectorAll(
      '[data-cart-count],.cart-count-bubble,.header__cart-count,.cart-count,[data-cart-item-count]'
    ).forEach(function (el) {
      var t = el.querySelector('span') || el;
      t.textContent = n;
      el.hidden = false;
      el.removeAttribute('hidden');
      if (n > 0) el.classList.remove('hidden', 'is-empty');
    });
  }

  function refresh() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { setCount(c.item_count); return c; })
      .catch(function () {});
  }

  function openDrawer() {
    // cart-drawer.liquid owns the refresh-then-show sequence
    if (typeof window.okCartRefresh === 'function') { window.okCartRefresh(); return; }
    document.dispatchEvent(new CustomEvent('cart:build'));
    document.dispatchEvent(new CustomEvent('product-ajax:added'));
    var tries = 12;
    (function poke() {
      var d = document.querySelector('cart-drawer');
      if (d && typeof d.show === 'function') { try { d.show(); return; } catch (e) {} }
      if (tries-- > 0) setTimeout(poke, 120);
    })();
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('form.ok-quickadd');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('button[type="submit"]');
    if (!btn || btn.__busy) return;
    btn.__busy = true;
    var label = btn.textContent;
    btn.textContent = 'Adding…';
    btn.disabled = true;

    var fd = new FormData(form);
    // drawer markup comes back with the add, so it never opens blank
    if (window.okCartSectionId) fd.append('sections', window.okCartSectionId);

    fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: fd })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function (j) {
        btn.textContent = 'Added ✓';
        var html = j && j.sections && window.okCartSectionId ? j.sections[window.okCartSectionId] : null;
        if (html && typeof window.okCartRefresh === 'function') { window.okCartRefresh(html); return; }
        return refresh().then(openDrawer);
      })
      .catch(function () { btn.textContent = 'Try again'; })
      .then(function () {
        setTimeout(function () {
          btn.textContent = label;
          btn.disabled = false;
          btn.__busy = false;
        }, 1600);
      });
  });

  /* rails: arrow buttons scroll the track */
  document.addEventListener('click', function (e) {
    var nav = e.target.closest && e.target.closest('.ok-rail__nav');
    if (!nav) return;
    var rail = nav.closest('.ok-rail');
    var track = rail && rail.querySelector('.ok-rail__track');
    if (!track) return;
    var dx = Math.max(240, track.clientWidth * 0.8);
    track.scrollBy({ left: nav.classList.contains('ok-rail__nav--prev') ? -dx : dx, behavior: 'smooth' });
  });
})();
